var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72168 7.35031C4.72168 5.64002 4.72168 4.78426 5.25327 4.25327C5.78426 3.72168 6.64002 3.72168 8.35031 3.72168H10.1646C11.8749 3.72168 12.7307 3.72168 13.2617 4.25327C13.7933 4.78426 13.7933 5.64002 13.7933 7.35031V10.3742C13.7933 12.0845 13.7933 12.9402 13.2617 13.4712C12.7307 14.0028 11.8749 14.0028 10.1646 14.0028H8.35031C6.64002 14.0028 5.78426 14.0028 5.25327 13.4712C4.72168 12.9402 4.72168 12.0845 4.72168 10.3742V7.35031Z",
    stroke: "#5070DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81432 11.2811C3.33313 11.2811 2.87165 11.09 2.5314 10.7497C2.19115 10.4095 2 9.948 2 9.46681V5.83818C2 3.55758 2 2.41698 2.70879 1.70879C3.41759 1.0006 4.55758 1 6.83818 1H9.25727C9.73845 1 10.1999 1.19115 10.5402 1.5314C10.8804 1.87165 11.0716 2.33313 11.0716 2.81432",
    stroke: "#5070DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7ee0547571f53943b4af56f36869afd4.svg";
export { ForwardRef as ReactComponent };